import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUndrawReviewed = (props) => /* @__PURE__ */ _jsxs("svg", {
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 837 438",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			"data-name": "Group 14",
			children: [
				/* @__PURE__ */ _jsx("path", {
					"data-name": "Path 284",
					d: "M812.405 234.609a10.138 10.138 0 01-2.678-15.312l-10.57-77.264 22.019 1.08 3.457 75.364a10.192 10.192 0 01-12.228 16.132z",
					fill: "#a0616a"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "Path 285",
					d: "M824.197 144.138a4.138 4.138 0 01-1.68 1.189l-19.789 7.552a4.157 4.157 0 01-5.28-2.194l-17.53-39.393a16.46 16.46 0 01-.805-11.65 16.01 16.01 0 0112.185-10.923 15.27 15.27 0 016.578.093 15.947 15.947 0 0111.461 9.963l15.585 41.2a4.166 4.166 0 01-.725 4.163z",
					fill: "#ccc"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "Path 286",
					d: "M721.082 423.193H707.39l-4.966-53.057 18.657.25z",
					fill: "#a0616a"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "Path 287",
					d: "M697.611 419.282h26.4v16.625h-43.028a16.625 16.625 0 0116.625-16.625h.003z",
					fill: "#2f2e41"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "Path 288",
					d: "M784.735 423.194h-13.69l-6.514-52.808h20.206z",
					fill: "#a0616a"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "Path 289",
					d: "M761.265 419.282h26.4v16.625h-43.028a16.625 16.625 0 0116.625-16.625h.003z",
					fill: "#2f2e41"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "Path 290",
					d: "M786.457 404.405l-21.5-1.592a5.032 5.032 0 01-4.655-4.768l-4.794-99.088a3.909 3.909 0 00-7.733-.6l-20 97.61a5.032 5.032 0 01-5.324 4l-19.438-1.554a5.025 5.025 0 01-4.608-5.41l.009-.098 18.033-180.326a5.025 5.025 0 016.068-4.41l68.574 14.907a5.038 5.038 0 013.957 5l-3.193 171.411a5.028 5.028 0 01-5.013 4.932c-.128 0-.255-.005-.383-.014z",
					fill: "#2f2e41"
				}),
				/* @__PURE__ */ _jsx("circle", {
					"data-name": "Ellipse 40",
					cx: 767.645,
					cy: 34.378,
					r: 27.428,
					fill: "#a0616a"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "Path 291",
					d: "M725.09 226.487a24.525 24.525 0 01-8.145-18.835c0-39.422 34.123-127.5 35.192-130.243.1-.662 1-.948 5.728-4.14s11.542-3.683 20.257-1.457a5 5 0 013.629 3.706l1.62 2.342a3.9 3.9 0 002.27 2.687c7.028 2.96 29.368 16.615 21.755 68-7.07 47.733-9.94 75.8-10.846 85.659a5.015 5.015 0 01-4.547 4.54c-3.446.308-9.36.719-16.4.719-16.334-.005-38.732-2.205-50.513-12.978z",
					fill: "#ccc"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "Path 292",
					d: "M692.314 211.881a10.137 10.137 0 016.31-14.207l34.275-70.047 17.682 13.168L711.46 205.3a10.192 10.192 0 01-19.143 6.581z",
					fill: "#a0616a"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "Path 293",
					d: "M752.516 143.333a4.137 4.137 0 01-2.058.05l-20.64-4.754a4.157 4.157 0 01-3.163-4.764l7.4-42.478a16.461 16.461 0 015.822-10.122 16.011 16.011 0 0116.205-2.281 15.269 15.269 0 015.41 3.742 15.947 15.947 0 013.965 14.659l-10.017 42.892a4.166 4.166 0 01-2.924 3.056z",
					fill: "#ccc"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "Path 294",
					d: "M761.223 59.16a11.82 11.82 0 01-3.17-10.482c.955-5 1.517-8.275 1.624-9.466.364-4.073-3.754-7.371-7.828-7.9a7.868 7.868 0 00-.4-.043c.1.1.215.206.313.3.774.727 1.737 1.632 1.508 2.566-.138.562-.652.96-1.57 1.218-6.373 1.783-11.28.146-15.446-5.155a12.313 12.313 0 01-2.35-5.135c-1.493-7.32 2.482-13.56 6.08-17.505 2.967-3.253 7.776-7.2 13.841-7.54 4.716-.263 10.325 2.45 12 7.342a9.112 9.112 0 017.1-4 16.374 16.374 0 019.111 2.534c13.3 7.618 19.015 25.766 12.481 39.63-4.11 8.72-13.015 15.213-23.239 16.943a11.613 11.613 0 01-1.937.164 11.3 11.3 0 01-8.125-3.467z",
					fill: "#2f2e41"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 336",
			d: "M363.66 195.57a7.6 7.6 0 00-6.95-4.65H217.983a7.524 7.524 0 00-7.52 7.52v175.5a7.524 7.524 0 007.52 7.52h138.73a7.53 7.53 0 007.52-7.52v-175.5a7.385 7.385 0 00-.57-2.87zm-1.1 178.37a5.857 5.857 0 01-5.85 5.85H217.983a5.851 5.851 0 01-5.85-5.85v-175.5a5.858 5.858 0 015.85-5.85h138.73a5.88 5.88 0 015.43 3.68 6.486 6.486 0 01.22.66 5.8 5.8 0 01.2 1.51z",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 337",
			d: "M334.71 232.355h-41.786a3.343 3.343 0 110-6.686h41.785a3.343 3.343 0 110 6.686z",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 338",
			d: "M334.71 249.905h-41.786a3.343 3.343 0 110-6.686h41.785a3.343 3.343 0 110 6.686z",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 339",
			d: "M271.483 259.898h-30.537a3.765 3.765 0 01-3.76-3.761V220.1a3.765 3.765 0 013.76-3.761h30.537a3.765 3.765 0 013.761 3.76v36.037a3.765 3.765 0 01-3.76 3.76z",
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 340",
			d: "M334.42 285.84h-94.437a3.343 3.343 0 010-6.685h94.436a3.343 3.343 0 110 6.686z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 341",
			d: "M334.42 303.39h-94.437a3.343 3.343 0 010-6.685h94.436a3.343 3.343 0 110 6.686z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 342",
			d: "M334.42 320.94h-94.437a3.343 3.343 0 010-6.685h94.436a3.343 3.343 0 110 6.686z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 343",
			d: "M334.42 338.49h-94.437a3.343 3.343 0 010-6.685h94.436a3.343 3.343 0 110 6.686z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 344",
			d: "M334.42 356.04h-94.437a3.343 3.343 0 010-6.685h94.436a3.343 3.343 0 110 6.686z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 349",
			d: "M640.004 437.462h195a1 1 0 000-2h-195a1 1 0 000 2z",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("circle", {
			"data-name": "Ellipse 44",
			cx: 289.696,
			cy: 116.373,
			r: 32.262,
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 395",
			d: "M286.5 128.68a3.346 3.346 0 01-2.013-.67l-.036-.026-7.582-5.8a3.37 3.37 0 114.1-5.348l4.91 3.766 11.606-15.14a3.368 3.368 0 014.722-.624l-.071.1.074-.1a3.372 3.372 0 01.623 4.724l-13.65 17.8a3.37 3.37 0 01-2.68 1.314z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			"data-name": "Ellipse 46",
			cx: 77.296,
			cy: 79.773,
			r: 21.862,
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 408",
			d: "M75.13 88.112a2.268 2.268 0 01-1.365-.453l-.024-.018-5.138-3.934a2.283 2.283 0 012.776-3.624l3.328 2.552 7.864-10.256a2.282 2.282 0 013.2-.423l-.049.067.05-.065a2.285 2.285 0 01.422 3.2l-9.25 12.064a2.283 2.283 0 01-1.816.89z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 410",
			d: "M138.731 131.033a5.982 5.982 0 00-5.468-3.66H24.103a5.92 5.92 0 00-5.918 5.918v138.093a5.92 5.92 0 005.917 5.917h109.161a5.925 5.925 0 005.917-5.917V133.29a5.81 5.81 0 00-.449-2.258zm-.865 140.352a4.609 4.609 0 01-4.6 4.6H24.102a4.6 4.6 0 01-4.6-4.6V133.29a4.609 4.609 0 014.6-4.6h109.161a4.626 4.626 0 014.273 2.9 5.108 5.108 0 01.173.519 4.559 4.559 0 01.158 1.188z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 411",
			d: "M115.949 159.978h-32.88a2.63 2.63 0 010-5.261h32.879a2.63 2.63 0 010 5.26z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 412",
			d: "M115.949 173.788h-32.88a2.63 2.63 0 010-5.261h32.879a2.63 2.63 0 010 5.26z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 413",
			d: "M66.197 181.65H42.17a2.962 2.962 0 01-2.959-2.958v-28.355a2.962 2.962 0 012.96-2.96h24.027a2.963 2.963 0 012.96 2.96v28.355a2.962 2.962 0 01-2.96 2.959z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 414",
			d: "M115.72 202.064H41.411a2.63 2.63 0 010-5.261h74.307a2.63 2.63 0 010 5.26z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 415",
			d: "M115.72 215.878H41.411a2.63 2.63 0 010-5.261h74.307a2.63 2.63 0 010 5.26z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 416",
			d: "M115.72 229.683H41.411a2.63 2.63 0 010-5.261h74.307a2.63 2.63 0 010 5.26z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 417",
			d: "M115.72 243.496H41.411a2.63 2.63 0 010-5.261h74.307a2.63 2.63 0 010 5.26z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 418",
			d: "M115.72 257.302H41.411a2.63 2.63 0 010-5.261h74.307a2.63 2.63 0 110 5.26z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 419",
			d: "M.791 277.877h153.434a.787.787 0 000-1.574H.791a.787.787 0 10-.008 1.574z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("circle", {
			"data-name": "Ellipse 46",
			cx: 497.296,
			cy: 79.773,
			r: 21.862,
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 408",
			d: "M495.13 88.112a2.268 2.268 0 01-1.365-.453l-.024-.018-5.138-3.934a2.283 2.283 0 012.776-3.624l3.328 2.552 7.864-10.256a2.282 2.282 0 013.2-.423l-.049.067.05-.065a2.285 2.285 0 01.422 3.2l-9.25 12.064a2.283 2.283 0 01-1.816.89z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 410",
			d: "M558.731 131.033a5.982 5.982 0 00-5.468-3.66h-109.16a5.92 5.92 0 00-5.918 5.918v138.093a5.92 5.92 0 005.917 5.917h109.161a5.925 5.925 0 005.917-5.917V133.29a5.81 5.81 0 00-.449-2.258zm-.865 140.352a4.609 4.609 0 01-4.6 4.6H444.102a4.6 4.6 0 01-4.6-4.6V133.29a4.609 4.609 0 014.6-4.6h109.161a4.626 4.626 0 014.273 2.9 5.108 5.108 0 01.173.519 4.559 4.559 0 01.158 1.188z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 411",
			d: "M535.948 159.978h-32.88a2.63 2.63 0 010-5.261h32.88a2.63 2.63 0 010 5.26z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 412",
			d: "M535.948 173.788h-32.88a2.63 2.63 0 010-5.261h32.88a2.63 2.63 0 010 5.26z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 413",
			d: "M486.197 181.65H462.17a2.962 2.962 0 01-2.959-2.958v-28.355a2.962 2.962 0 012.96-2.96h24.027a2.963 2.963 0 012.96 2.96v28.355a2.962 2.962 0 01-2.96 2.959z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 414",
			d: "M535.72 202.064h-74.308a2.63 2.63 0 010-5.261h74.307a2.63 2.63 0 010 5.26z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 415",
			d: "M535.72 215.878h-74.308a2.63 2.63 0 010-5.261h74.307a2.63 2.63 0 010 5.26z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 416",
			d: "M535.72 229.683h-74.308a2.63 2.63 0 010-5.261h74.307a2.63 2.63 0 110 5.26z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 417",
			d: "M535.72 243.496h-74.308a2.63 2.63 0 010-5.261h74.307a2.63 2.63 0 010 5.26z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 418",
			d: "M535.72 257.302h-74.308a2.63 2.63 0 110-5.261h74.307a2.63 2.63 0 110 5.26z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 419",
			d: "M420.791 277.877h153.434a.787.787 0 000-1.574H420.791a.787.787 0 10-.008 1.574z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 420",
			d: "M189.004 382.059h195a1 1 0 000-2h-195a1 1 0 000 2z",
			fill: "#3f3d56"
		})
	]
});
export default SvgUndrawReviewed;
